export default __webpack_public_path__ + "static/media/mobile-project.58d49ac7.png";